import { render, staticRenderFns } from "./ComInfo.vue?vue&type=template&id=a9dd5314&scoped=true&"
import script from "./ComInfo.vue?vue&type=script&lang=js&"
export * from "./ComInfo.vue?vue&type=script&lang=js&"
import style0 from "./ComInfo.vue?vue&type=style&index=0&id=a9dd5314&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9dd5314",
  null
  
)

export default component.exports